import { Space } from '@cocoplatform/coco-rtc-shared';
import cc from 'classcat';
import React from 'react';
import C from './SpaceRecencyTag.css';
import { hrToMS, minToMS } from '../../utils/date';

// Schedule update in intervals
export default function SpaceRecencyTag(p: {
  size?: 'small' | 'large';
  msg: string;
}) {
  return (
    <div className={cc([C.recencyTag, C[p.size ?? 'small']])}>
      <div className={C.recencyArrow} />
      <span>{p.msg}</span>
    </div>
  );
}
